<template>
  <md-field>
    <label>掛號時段</label>
    <md-select v-model="selectedTimeIndex">
      <md-option v-for="(time, index) in ranges" :ranges="ranges" :key="index" :value="index">{{getHour(time.from)}} - {{getHour(time.until)}}</md-option>
    </md-select>
  </md-field>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      selectedTime: { },
      ranges: []
    }
  },
  props: ['date', 'time'],
  created: function () {
    this.ranges = this.getRanges(this.date)
  },
  components: {
  },
  computed: {
    dateString: function () {
      return moment(this.date).toISOString()
    },
    selectedTimeIndex: {
      get: function () {
        return this.time || 0
      },
      set: function (v) {
        this.$emit('change', [this.ranges[v].from, this.ranges[v].until])
      }
    }
  },
  watch: {
    date: function (newVal) {
      this.ranges = this.getRanges(newVal)
      this.$emit('change', [this.ranges[this.time].from.toISOString(), this.ranges[this.time].until.toISOString()])
      if (!this.time) {
        this.selectedTimeIndex = 0
      }
    }
  },
  methods: {
    getRanges (date = moment()) {
      if (!date) {
        date = moment()
      }
      let ranges = []
      for (var i = 0; i < 24; i++) {
        let from = moment(date).set('hour', i).startOf('hour')
        let until = moment(date).set('hour', i + 1).startOf('hour')
        ranges.push({
          from,
          until,
          from_str: from.toISOString(),
          until_str: until.toISOString()
        })
      }
      return ranges
    },
    getHour (value) {
      return moment(value).get('hour')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Shared/TimeRange.vue